import clsx from 'clsx';
import styles from './styles.module.scss';

type StatusProps = {
  status: string | undefined;
  className?: any;
  statusTitle?: any;
};

enum StatusType {
  'Available' = 'Available',
  'InModeration' = 'InModeration',
  'Rejected' = 'Rejected',
  'InAnalysis' = 'InAnalysis',
  'Archived' = 'Archived',
}

const Status: React.FC<StatusProps> = (props) => {
  const { className, status, statusTitle, ...rest } = props;
  return (
    <button
      type='button'
      className={clsx(styles.button, styles[`tag${StatusType[status as keyof typeof StatusType]}`])}
    >
      <span className={styles.content}>{statusTitle}</span>
    </button>
  );
};

export default Status;
